import { Paper, Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { SearchAvailabilityResultItem } from '../../types/bookingta'
import BreadcrumbsSkelton from './breadcrumb.skeleton'
import useStyles from './styles/index'

type Level = {
  label: string
  link?: string
}

interface BreadcrumbsProps {
  levels: Level[]
  boxShadow?: boolean
  loading: boolean
  data?: SearchAvailabilityResultItem | undefined
  loadingForSearchAvailability?: boolean
}
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  loadingForSearchAvailability,
  data,
  levels,
  boxShadow,
  loading
}) => {
  const classes = useStyles()

  return (
    <Paper
      className={[classes.topBar, boxShadow ? classes.boxShadow : ''].join(
        ' '
      )}>
      <div className={classes.mainBreadCrums}>
        {loading ? (
          <BreadcrumbsSkelton numberOfLevels={levels.length} />
        ) : (
          levels
            .filter((level) => !!level.label)
            .map((level, index) => {
              if (level.link) {
                return (
                  <div key={index}>
                    <LocalizedLink
                      key={level.label}
                      to={`${level.link}`}
                      className={classes.link}>
                      <Typography variant="body1" className={classes.label}>
                        {getTranslate(level.label) + ' / '} &nbsp;
                      </Typography>
                    </LocalizedLink>
                  </div>
                )
              } else {
                const isPersian = persianRegex.test(level.label)
                return (
                  <Typography
                    style={isPersian ? { fontFamily: 'IranSans' } : undefined}
                    key={level.label}
                    variant="body1"
                    className={classes.LastLabel}>
                    {getTranslate(level.label)}&nbsp;
                  </Typography>
                )
              }
            })
        )}
        &nbsp;
        {!loadingForSearchAvailability && (
          <>
            {data && (
              <div className={classes.mainBalance}>
                <div className={classes.containerBalance}>
                  <Typography className={classes.textLimit}>
                    {getTranslate('Balance :')}
                  </Typography>
                  &nbsp;
                  <Typography className={classes.priceLimit}>
                    {lang === 'en' ? 'IRR' : ''}
                    {addCommaToPrice(data?.accountBalance || 0)}
                    &nbsp;{lang === 'fa' ? 'ریال' : ''}
                  </Typography>
                </div>
                &nbsp; &nbsp;
                <div className={classes.containerLimit}>
                  <Typography className={classes.textLimit}>
                    {getTranslate('Limit :')}
                  </Typography>
                  &nbsp;
                  <Typography className={classes.priceLimit}>
                    {lang === 'en' ? 'IRR' : ''}
                    {addCommaToPrice(data?.accountLowerLimit || 0)}
                    &nbsp;{lang === 'fa' ? 'ریال' : ''}
                  </Typography>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Paper>
  )
}
export default Breadcrumbs
